import React from "react";
import { LoadingDots } from "@sscs/ui";
import { PERMISSION } from "Constants";
import { useAllowedTo, useLoginInfo, useRedirect } from "Hooks";

type RestrictedAccessProps = {
  children: React.ReactElement | React.ReactElement[];
};

const RestrictedAccess = ({
  children,
}: RestrictedAccessProps): React.JSX.Element => {
  const { hasLoaded } = useLoginInfo();

  const isAdmin = useAllowedTo({
    permissions: [PERMISSION.SETUP_SSO],
  });

  useRedirect({
    to: "/page-not-found",
    when: hasLoaded && !isAdmin,
  });

  if (!hasLoaded || !isAdmin) {
    return <LoadingDots />;
  }

  return <>{children}</>;
};

export default RestrictedAccess;
